import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "menu-editor" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "items"
}
const _hoisted_4 = ["onClick"]

import { computed, ref } from "vue";
import SvgIcon from "@/common/components/image/svgIcon.vue";
import type { ReportType, ReportBlockType } from "@/common/types/report";


export default /*@__PURE__*/_defineComponent({
  __name: 'menu',
  props: {
    block: {}
  },
  emits: ["block:add"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const accordions = ref<string[]>(["block", "data", "layout"]);

const menus = computed(() => [
  {
    title: "Básico",
    key: "block",
    items: [
      // title
      {
        key: "block-title",
        label: "Título",
        props: {
          content: { ops: [{ insert: "Edite seu título aqui..." }] },
          id: "block-title",
          style: {
            background: "#dedede",
            color: "#000000",
            "font-family": "Calibri",
            "font-size": "20px",
            "font-style": "normal",
            "font-weight": "bold",
            "line-height": "1.5",
            "margin-top": "10px",
            "margin-bottom": "20px",
            "margin-left": "0px",
            "margin-right": "0px",
            "padding-top": "5px",
            "padding-bottom": "2px",
            "padding-left": "15px",
            "padding-right": "0px",
            "text-align": "left",
            "text-decoration": "none",
          },
          type: "block-title",
        },
      },
      // text
      {
        key: "block-text",
        label: "Texto",
        props: {
          content: { ops: [{ insert: "Edite seu texto aqui..." }] },
          id: "block-text",
          style: {
            color: "#000000",
            "font-size": "15px",
            "font-style": "normal",
            "font-family": "Verdana",
            "font-weight": "normal",
            "line-height": "1.6",
            "text-align": "justify",
          },
          type: "block-text",
        },
      },
      // table
      {
        key: "block-table",
        label: "Tabela",
        props: {
          content: {
            title: "Título da Tabela",
            table: null,
            filters: [],
            columns: [],
            rows: [],
          },
          id: "block-table",
          style: {
            color: "#000000",
            "font-size": "16px",
            "font-style": "normal",
            "font-weight": "normal",
            "font-family": "Verdana",
          },
          type: "block-table",
        },
      },
      // block
      {
        key: "block-data",
        label: "Bloco",
        props: {
          content: {
            title: "Título do Bloco",
            table: null,
            filters: [],
            columns: [],
            fields: [],
            rows: [],
          },
          id: "block-data",
          style: {
            color: "#000000",
            "font-size": "16px",
            "font-style": "normal",
            "font-weight": "normal",
            "font-family": "Verdana",
          },
          type: "block-data",
        },
      },
    ],
  },
  // {
  //   title: "Bloco de Dados",
  //   key: "data",
  //   items: [
  //     { key: "evaluation", label: "Avaliação" },
  //     { key: "analyse", label: "Análise" },
  //     { key: "company", label: "Empresa" },
  //     { key: "employees", label: "Funcionários" },
  //     { key: "forms", label: "Formulários" },
  //     { key: "methods", label: "Métodos" },
  //     { key: "equipments", label: "Equipamentos" },
  //     { key: "samples", label: "Amostras" },
  //     { key: "signatures", label: "Assinaturas" },
  //     { key: "signatures", label: "Assinaturas" },
  //   ],
  // },
]);

function toggleAccordion(section: string) {
  if (accordions.value.includes(section)) {
    accordions.value = accordions.value.filter((s) => s !== section);
  } else {
    accordions.value.push(section);
  }
}

function selectBlock(data: any) {
  emit("block:add", { key: data.key, content: data.props });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (menu) => {
      return (_openBlock(), _createElementBlock("div", {
        key: menu.key,
        class: "list"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["accordion", {
            open: accordions.value.includes(menu.key),
          }]),
          onClick: ($event: any) => (toggleAccordion(menu.key))
        }, [
          _createTextVNode(_toDisplayString(menu.title) + " ", 1),
          (accordions.value.includes(menu.key))
            ? (_openBlock(), _createBlock(SvgIcon, {
                key: 0,
                icon: "arrow-up",
                size: "1rem"
              }))
            : (_openBlock(), _createBlock(SvgIcon, {
                key: 1,
                icon: "arrow-down",
                size: "1rem"
              }))
        ], 10, _hoisted_2),
        (accordions.value.includes(menu.key))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: "item",
                  onClick: ($event: any) => (selectBlock(item))
                }, _toDisplayString(item.label), 9, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})